import { PropsWithChildren, createContext } from 'react'

import { createContextHook } from '../../../lib/utils'

import { ICollectionFilterQueryParamsContext } from './types'
import { useCollectionFilterQueryParams } from './useCollectionFilterQueryParams'

export const CollectionFilterQueryParamsContext = createContext<
  ICollectionFilterQueryParamsContext | undefined
>(undefined)

export const useCollectionFilterQueryParamsContext = createContextHook(
  CollectionFilterQueryParamsContext,
  'CollectionFilterQueryParamsContext'
)

export type UpdateQueryParamsOptions = {
  /** Shallow routing when `shallow` is true (default), full route navigation when false. */
  shallow?: boolean
  /** Scroll to top. Only honored when `shallow` is `false`. Defaults to `false`. */
  scroll?: boolean
}

/** Generic interface that defines the implementation of a query parameter management hook */
export interface UseQueryParams {
  query: Record<string, string | string[] | undefined>
  updateQueryParams: (updatedQueryParams: Record<string, string | undefined>) => void
}

export const CollectionFilterQueryParamsContextProvider = ({
  children,
  collectionHandle,
  useQueryParamsImpl,
}: PropsWithChildren<{
  useQueryParamsImpl: () => UseQueryParams
  collectionHandle: string | null
}>) => {
  return (
    <CollectionFilterQueryParamsContext.Provider
      value={useCollectionFilterQueryParams({ useQueryParamsImpl, collectionHandle })}
    >
      {children}
    </CollectionFilterQueryParamsContext.Provider>
  )
}
